<template>
  <div>
    <v-btn
      color="primary"
      dark
      class="mr-5"
      v-if="customerId"
      :disabled="isAllTextFieldDisable"
      @click="selectRepairPriceBomItemsBtn"
    >
      選擇修改Bom細項
    </v-btn>
    <v-dialog v-model="isShowEditCustomerRepairBomItemDialog" fullscreen persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">{{ $t('common_edit') }}</span>
        </v-card-title>
        <v-data-table
          :headers="customerRepairBomItemDataTableHeaders"
          :items="computedCustomerRepairBomItems"
          class="elevation-1 ma-5 "
          :search="searchCustomerRepairBomItem"
          :loading-text="$t('common_get_data')"
          :no-data-text="$t('common_no_data')"
          :no-results-text="$t('common_no_results')"
          :footer-props="{
            'items-per-page-options': [30, 50, 100],
            'items-per-page-text': $t('item_rows_per_page'),
          }"
          :header-props="headerProps"
          v-model="selectCustomerRepairBomItems"
          item-key="Index"
          show-select
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>{{ $t('customer_repair_item_toolbar_title') }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchCustomerRepairBomItem"
                append-icon="mdi-magnify"
                :label="$t('customer_repair_item_search_label')"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-toolbar>
          </template>
          <template v-slot:[`item.OriginalType`]="{ item }">
            {{ convertOriginalType(item.OriginalType) }}
          </template>
        </v-data-table>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            text
            @click="closeSelectCustomerRepairBomItems"
            :disabled="isAllTextFieldDisable"
          >
            {{ $t('common_cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            :disabled="selectCustomerRepairBomItems.length === 0"
            text
            @click="addSelectCustomerRepairBomItems"
          >
            {{ $t('common_confirm') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { HttpUpdateCustomerRepair } from '@/js/http-Manager'
import { OriginalType } from '@/js/OriginalType'
export default {
  name: 'SelectRepairPriceBomItem',
  data: () => ({
    searchCustomerRepairBomItem: '',
    isShowEditCustomerRepairBomItemDialog: false,
    customerRepairBomItems: [],
    selectCustomerRepairBomItems: []
  }),
  props: {
    isAllTextFieldDisable: {
      type: Boolean,
      default: false
    },
    customerId: {
      type: String
    }
  },
  mounted () {},
  watch: {},
  computed: {
    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    customerRepairBomItemDataTableHeaders () {
      return [
        { text: '預設來源', align: 'start', value: 'OriginalType' },
        { text: 'BOM名稱', align: 'start', value: 'BomName' },
        { text: 'BOM描述', align: 'start', value: 'BomDescribe' },
        { text: this.$t('customer_repair_item_new_number'), align: 'start', value: 'Number' },
        { text: this.$t('customer_repair_item_new_name'), align: 'start', value: 'Name' },
        { text: '新品維修保固期數', align: 'end', value: 'RepairWarrantyPeriod' },
        { text: '新品維修價格', align: 'end', value: 'RepairPrice' },
        { text: this.$t('customer_repair_item_old_number'), align: 'start', value: 'OldNumber' },
        { text: this.$t('customer_repair_item_old_name'), align: 'start', value: 'OldName' },
        {
          text: '良品維修保固期數',
          align: 'end',
          value: 'OldRepairWarrantyPeriod'
        },
        {
          text: '良品維修價格',
          align: 'end',
          value: 'OldRepairPrice'
        },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    },
    computedCustomerRepairBomItems () {
      let array = []
      if (this.customerRepairBomItems) {
        this.customerRepairBomItems.forEach((item, index) => {
          array.push({
            ...item,
            Index: index + 1
          })
        })
      }
      return array
    }
  },
  methods: {
    convertOriginalType (originalType) {
      return OriginalType.getOriginalTypeName(originalType)
    },
    async selectRepairPriceBomItemsBtn () {
      await this.getCustomerRepairBomItems()
      this.isShowEditCustomerRepairBomItemDialog = true
    },
    closeSelectCustomerRepairBomItems () {
      this.selectCustomerRepairBomItems = []
      this.customerRepairBomItems = []
      this.isShowEditCustomerRepairBomItemDialog = false
    },
    addSelectCustomerRepairBomItems () {
      this.$emit('addSelectCustomerRepairBomItems', this.selectCustomerRepairBomItems)
      this.closeSelectCustomerRepairBomItems()
    },
    async getCustomerRepairBomItems () {
      let param = {
        customerId: this.customerId
      }
      let response = await HttpUpdateCustomerRepair.GetCustomerRepairBomItems(param)
      if (response && response.status === 200) {
        this.customerRepairBomItems = response.data.Data
      }
    }
  }
}
</script>
